import i18n from '@/utils/i18n';
import React from 'react';
import {
  ActionSheet,
  Button,
  Typography,
  YStack,
} from '@usepepper/sprout-kit-ui';

const SNAP_POINTS = [30];

interface InsightsMobileClearAllActionSheetProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  open: boolean;
}

export const InsightsMobileClearAllActionSheet: React.FC<
  InsightsMobileClearAllActionSheetProps
> = ({ loading, onCancel, onConfirm, open }) => (
  <ActionSheet
    onOpenChange={(next) => {
      if (!next) {
        onCancel();
      }
    }}
    open={open}
    snapPoints={SNAP_POINTS}
  >
    <ActionSheet.Header>
      <ActionSheet.Title>
        {i18n.t('insights_hub.clear_confirmation_sheet.title')}
      </ActionSheet.Title>
    </ActionSheet.Header>
    <ActionSheet.Body>
      <YStack gap="$16">
        <Typography variant="body">
          {i18n.t('insights_hub.clear_confirmation_sheet.body')}
        </Typography>
        <YStack gap="$8">
          <Button
            aria-label={i18n.t('clear')}
            loading={loading}
            onPress={onConfirm}
            variant="error"
            width="100%"
          >
            {i18n.t('clear')}
          </Button>
          <Button
            aria-label={i18n.t('cancel')}
            onPress={onCancel}
            variant="secondary"
            width="100%"
          >
            {i18n.t('cancel')}
          </Button>
        </YStack>
      </YStack>
    </ActionSheet.Body>
  </ActionSheet>
);
